/* eslint-disable react/button-has-type */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './style.scss';

function TabButton({
  label = 'Button',
  disabled = false,
  disabledClassName = 'tv-tab_button--disabled',
  ...props
}) {
  const btnClass = classNames({
    'tv-tab_button': true,
    [`${disabledClassName}`]: disabled,
  });
  return (
    <button
      type="button"
      {...props}
      className={`${btnClass} ${props.className}`}
    >
      {label}
    </button>
  );
};

TabButton.propTypes = {
  disabled: PropTypes.bool,
  className: PropTypes.string,
  disabledClassName: PropTypes.string,
  label: PropTypes.string,
  props: PropTypes.shape({}),
};

export default TabButton;
